// extracted by mini-css-extract-plugin
export const input = "PlaceholderTextField-module--input--1fg-P";